import * as actionMenu from "../widget/action-menu-registry.ts"
import * as Medias from "../server/Medias.ts";
import * as Html from "../util/Html.ts";
import * as FwDatas from "../FwDatas.ts";

import { pickFile } from "../filer/filerModal.ts";
import { iconsimple, pickFileFromDevice } from "../lib/FileUtils.ts";
import Icons from "../svg/Icons.ts";
import { toastMaxAttachmentReach } from "../util/modal.ts";
import * as actionMenuWidget from "../widget/action-menu.ts";

Html.registerWidget('form/multifile',{initDom})

export function initDom(node :HTMLElement){
  var
    input = node.querySelector('input')||node as HTMLInputElement,
    dbObject = FwDatas.get(Html.getDomMetaId(node));
  
  node.setAttribute("data-key","addfileinmodal");
  actionMenuWidget.initDom(node);
   
  input.customFiles = []
  if(dbObject?.medias){
    dbObject.medias.forEach(media=>{
      input.customFiles.push(media)
    })
  }
  if(node.getAttribute("data-ui")==="simple"){
    input.addEventListener('change',()=>{
      node.classList.toggle('color-branded',input.customFiles.length>0)
    })
  }else{
    input.addEventListener('change',()=>{
      //clean html
      var crawler = node.previousElementSibling;
      while(crawler?.classList.contains('filer-file')){
        var nextCrawler = crawler.previousElementSibling;
        crawler.remove()
        crawler = nextCrawler
      }
      input.customFiles.forEach(file=>{
        node.insertAdjacentHTML('beforebegin',itemhtml(file))
      })
    })
    input.dispatchEvent(new Event('change'))
  }

}

function itemhtml(item){
  return `<flexrow class="border-pane filer-file">
    ${iconsimple(item,"font-size:24px")}
    <flexauto class="line">${Html.escape(item.name)}</flexauto>
    <icon data-fw-onclick="removemediafrominput" style="opacity:0.5">${Icons.ic_close_circle}</icon>
  </flexrow>`
}

actionMenu.register({
  addfileinmodal(){
    var
      node = this,
      LIMIT = parseInt(node.getAttribute('data-limit')),
      LIMIT_FREEMIUM = parseInt(node.getAttribute('data-limit-freemium')),
      inputFile = node.querySelector('input')||node as HTMLInputElement,
      menu = [],
      potentialAdd = LIMIT - inputFile.customFiles.length,
      maxAdd = FwDatas.getPermission('filer')==='KO_PREMIUM'?LIMIT_FREEMIUM - inputFile.customFiles.length : potentialAdd;

    if(inputFile.customFiles.length>=LIMIT){
      toastMaxAttachmentReach(LIMIT)
      return;
    }

    if(FwDatas.getPermission('filer')==='KO_PREMIUM' && inputFile.customFiles.length>=LIMIT_FREEMIUM){
      Html.trigger(null,'takepremium')
      return;

    }

    menu.push({svg:Icons.ic_gallery, async clickFunction(){
      if(!await Medias.checkQuota()) return;
      var
        files = await pickFileFromDevice('image/*',maxAdd>1),
        filesLimited = files.slice(0,maxAdd);
      if(filesLimited.length<files.length) toastMaxAttachmentReach(LIMIT);
      filesLimited.forEach(file=>{
        inputFile.customFiles.push(file)
        inputFile.dispatchEvent(new Event('change'))
      })

    },i18nkey:'actions.addpicture'});

    menu.push({svg:Icons.filer.ic_upload, async clickFunction(){
      if(!await Medias.checkQuota()) return;
      var
        files = await pickFileFromDevice('*/*',maxAdd>1),
        filesLimited = files.slice(0,Math.max(0,maxAdd));
      if(filesLimited.length<files.length) toastMaxAttachmentReach(LIMIT);
      filesLimited.forEach(file=>{
        inputFile.customFiles.push(file)
        inputFile.dispatchEvent(new Event('change'))
      })

    },i18nkey:'actions.attachfile'})

    menu.push({svg:Icons.ic_insert_file, async clickFunction(){
      var media = await pickFile({title:'actions.attachfilefromfiler'});
      if(media){
        inputFile.customFiles.push(media)
        inputFile.dispatchEvent(new Event('change'))
      }
    },i18nkey:'actions.attachfilefromfiler'})

    if(FwDatas.getPermission('filer')==='KO_PREMIUM'){
      menu.slice(1).forEach(button=>{
        button.svgend = Icons.ic_premium_feature_indicator
        button.clickFunction = undefined;
        button.onclick = 'takepremium'
      })
    }
    if(inputFile.customFiles.length>0){
      menu.push({svg:Icons.ic_delete,color:'var(--red)', async clickFunction(){
      inputFile.customFiles = []
      inputFile.dispatchEvent(new Event('change'))
      
    },i18nkey:'actions.delete'})
    }

    return {menu}
  }
})
Html.registerDom({
  removemediafrominput(){
    let parent = this.parentElement as Element;
    const input = parent.closest("form")?.querySelector('[data-key="addfileinmodal"]') as HTMLInputElement;
    if(!input) return;
    let index = 0, crawler = parent;
    while(crawler.previousElementSibling?.classList.contains('filer-file')){
      crawler = crawler.previousElementSibling;
      index++;
    }

    input.customFiles.splice(index,1)
    input.dispatchEvent(new Event('change'))
  }
})